import { Injectable, signal } from '@angular/core';

export interface ModalConfig {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  resolve?: (value: boolean) => void;
}

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  currentModal = signal<ModalConfig | null>(null);

  confirm(title: string, message: string, confirmText = 'Confirm', cancelText = 'Cancel'): Promise<boolean> {
    return new Promise((resolve) => {
      this.currentModal.set({
        title,
        message,
        confirmText,
        cancelText,
        resolve
      });
    });
  }

  close(result: boolean) {
    const modal = this.currentModal();
    if (modal && modal.resolve) {
      modal.resolve(result);
    }
    this.currentModal.set(null);
  }
}
